module.exports = __webpack_public_path__ + "img/ic-right-grey.8b5f9eae.svg";